import { useMemo, useState } from "react";
import { MagnifyingGlass, CheckCircle } from "@phosphor-icons/react";
import { inr } from "@/lib/dseQuotes";

export default function DseModelPicker({ rows, value, onChange }) {
  const [q, setQ] = useState("");
  const [family, setFamily] = useState("");
  const families = useMemo(() => [...new Set(rows.map((r) => r.family || "Other"))].sort(), [rows]);
  const list = useMemo(() => {
    const s = q.trim().toLowerCase();
    return rows.filter((r) => r.active !== false
      && (!family || (r.family || "Other") === family)
      && (!s || r.package_name.toLowerCase().includes(s)));
  }, [rows, q, family]);

  return (
    <div className="space-y-2" data-testid="dse-model-picker">
      <div className="relative">
        <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-ink-muted" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search model…"
          data-testid="dse-model-search"
          className="w-full border border-canvas-line bg-white pl-9 pr-3 py-3 text-sm focus:outline-none focus:border-ink" />
      </div>
      <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1">
        {["", ...families].map((f) => (
          <button key={f || "all"} type="button" onClick={() => setFamily(f)} data-testid={`dse-family-${f || "all"}`}
            className={`shrink-0 px-3 py-1.5 text-xs font-mono uppercase tracking-wider border transition-colors ${
              family === f ? "bg-ink text-white border-ink" : "border-canvas-line text-ink-muted"}`}>
            {f || "All"}
          </button>
        ))}
      </div>
      <div className="max-h-72 overflow-y-auto border border-canvas-line divide-y divide-canvas-line bg-white">
        {list.length === 0 && <div className="p-4 text-sm text-ink-muted">No models match.</div>}
        {list.map((r) => {
          const on = value?.id === r.id;
          return (
            <button key={r.id} type="button" onClick={() => onChange(r)} data-testid={`dse-model-${r.id}`}
              className={`w-full flex items-center justify-between gap-3 px-3 py-3 text-left transition-colors ${on ? "bg-ink text-white" : "hover:bg-canvas"}`}>
              <span className="text-sm font-medium leading-tight">{r.package_name}</span>
              <span className="flex items-center gap-2 shrink-0 font-mono text-sm">
                {inr(r.dealer_price)}
                {on && <CheckCircle size={18} weight="fill" />}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
